module.exports = __webpack_public_path__ + "img/datacenter.d031540d.jpg";